export const projectsInsuranceClaimsReadinessProviderId = 'projects.server.insurance-claims-readiness';
//# sourceMappingURL=projects-insurance-claims-readiness.contract.js.map